/**
 * AuthSplitLayout — the desktop split sign-in screen shared by the public
 * auth pages. On large viewports it shows a full-bleed showroom photo with the
 * PROVIDE CARS brand lockup on the left and a white form card on the right;
 * mobile collapses to a plain centred card (no photo).
 *
 * This mirrors the AUCNET Stock front (`aucnet-stock-front-user`
 * register/login split) so that, with Customer Portal as the single IdP
 * (ADR 013), the sign-in surface a Stock user is handed off to reads as the
 * same product. Styles live in `styles/globals.css` under `.auth-split`.
 */
import type { ReactNode } from 'react';

export function AuthSplitLayout({ children }: { children: ReactNode }): JSX.Element {
  return (
    <section className="auth-split">
      <AuthBrandLockup />
      <div className="auth-split__card">{children}</div>
    </section>
  );
}

/** Decorative brand lockup over the photo (desktop only; aria-hidden). */
function AuthBrandLockup(): JSX.Element {
  return (
    <div className="auth-split__brand" aria-hidden="true">
      <img
        src="/logos/provide-cars-icon.svg"
        alt=""
        width={60}
        height={60}
        className="auth-split__brand-emblem"
      />
      <p className="auth-split__brand-name">PROVIDE CARS</p>
      <p className="auth-split__brand-line1">Japanese Used Car Stock</p>
      <p className="auth-split__brand-line2">Sourced through AUCNET stock Platform</p>
    </div>
  );
}
